import React, { useState, useRef, useEffect } from 'react';
import { CopyToClipboard } from 'react-copy-to-clipboard';
import { MdIosShare} from "react-icons/md";
import { FaWhatsappSquare } from "react-icons/fa";
import { MdMessage } from "react-icons/md";
import { SiGmail } from "react-icons/si";
import { MdEmail } from "react-icons/md";

const ShareButton = () => {
  const [isOpen, setIsOpen] = useState(false);
  const modalRef = useRef(null);  // Reference to the modal content
  const currentUrl = window.location.href;

  const handleToggle = () => {
    setIsOpen(!isOpen);
  };

  
  const handleOutsideClick = (event) => {
    // Check if the click is outside the modal content
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setIsOpen(false);
    }
  };

  useEffect(() => {
    // Add event listener to close modal if clicked outside
    if (isOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
    } else {
      document.removeEventListener('mousedown', handleOutsideClick);
    }

    // Cleanup the event listener on component unmount
    return () => {
      document.removeEventListener('mousedown', handleOutsideClick);
    };
  }, [isOpen]);

  const shareOptions = [
    {
 icon:<MdEmail />,
      url: `mailto:?subject=Check this out&body=Here is a link: ${currentUrl}`,
    },
    {
      name: 'Gmail',
      icon: <SiGmail />,
      url: `https://mail.google.com/mail/?view=cm&fs=1&to=&su=Check this out&body=Here is a link: ${currentUrl}`,
    },
    {
      name: 'WhatsApp',
      icon: <FaWhatsappSquare />,
      url: `https://wa.me/?text=Check this out: ${currentUrl}`,
    },
    {
      name: 'Message',
      icon: <MdMessage />,
      url: `sms:?body=Check this out: ${currentUrl}`,
    },
    {
      name: 'Copy Link',
      icon: <MdIosShare />,
      url: currentUrl,
    },
  ];

  return (
    <div>
      <MdIosShare onClick={handleToggle} style={{ width: 35, cursor: 'pointer' }} />
      
      {isOpen && (
        <div style={modalOverlayStyle}>
          <div ref={modalRef} style={modalContentStyle}>
            <button onClick={handleToggle} style={closeButtonStyle}>
              Close
            </button>

            <h3 style={{color:"white"}}>Share this page:</h3>
            <ul style={listStyle}>
              {shareOptions.map((option, index) => (
                <li key={index} style={listItemStyle}>
                  {option.name === 'Copy Link' ? (
                    <CopyToClipboard text={option.url}>
                      <button style={buttonStyle}>
                        {option.icon} Copy Link
                      </button>
                    </CopyToClipboard>
                  ) : (
                    <a href={option.url} target="_blank" rel="noopener noreferrer" style={linkStyle}>
                      {option.icon} Share via {option.name}
                    </a>
                  )}
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

// Styles for components (you can replace these with your custom styles)
const buttonStyle = {
  padding: '10px 20px',
  backgroundColor: '#007bff',
  color: 'white',
  border: 'none',
  borderRadius: '4px',
  cursor: 'pointer',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

const modalOverlayStyle = {
  position: 'fixed',
  top: 0,
  left: 0,
  width: '100%',
  height: '100%',
  backgroundColor: 'rgba(236, 194, 194, 0.8)', // Red background with opacity
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
};

const modalContentStyle = {
  backgroundColor: 'black',
  padding: '20px',
  borderRadius: '8px',
  maxWidth: '400px',
  width: '100%',
  position: 'relative',
};

const closeButtonStyle = {
  position: 'absolute',
  top: '10px',
  right: '10px',
  background: 'none',
  border: 'none',
  fontSize: '18px',
  cursor: 'pointer',
};

const listStyle = {
  listStyleType: 'none',
  padding: 0,
};

const listItemStyle = {
  marginBottom: '10px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

const linkStyle = {
  textDecoration: 'none',
  color: '#007bff',
  fontSize: '16px',
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
};

export default ShareButton;
